module.exports = __webpack_public_path__ + "static/aboutIllustration-3d4c7a9a7a1b9834d13397e1f495e0e7.svg";